import { OutputEmitterRef } from '@angular/core';

export abstract class AddToWatchlist {
  symbolAdded: OutputEmitterRef<void>;
}
